import { makeStyles } from '@material-ui/styles'
import React, { useEffect, useState } from 'react'
import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'
import Theme from 'core/themes/model'
import { getTimeRangeData } from 'core/utils/helpers'

export const TIME_RANGES = {
  last_5_minutes: 'last_5_minutes',
  last_15_minutes: 'last_15_minutes',
  last_30_minutes: 'last_30_minutes',
  last_1_hour: 'last_1_hour',
  last_3_hours: 'last_3_hours',
  last_6_hours: 'last_6_hours',
  last_12_hours: 'last_12_hours',
  last_24_hours: 'last_24_hours',
  last_48_hours: 'last_48_hours',
  last_7_days: 'last_7_days',
  last_30_days: 'last_30_days',
  last_60_days: 'last_60_days',
}

export const TIME_RANGE_LABELS = {
  last_5_minutes: 'Last 5 Minutes',
  last_15_minutes: 'Last 15 Minutes',
  last_30_minutes: 'Last 30 Minutes',
  last_1_hour: 'Last 1 Hour',
  last_3_hours: 'Last 3 Hours',
  last_6_hours: 'Last 6 Hours',
  last_12_hours: 'Last 12 Hours',
  last_24_hours: 'Last 24 Hours',
  last_48_hours: 'Last 48 Hours',
  last_7_days: 'Last 7 Days',
  last_30_days: 'Last 30 Days',
  last_60_days: 'Last 60 Days',
}

export interface TimeRangePicklist {
  label: string
  value: string
}
interface Props {
  onChange: (
    selectedTimeRange: string,
    startTimeEpoch: number,
    endTimeEpoch: number,
    steps: string,
    interval?: number,
  ) => void
  defaultTimeRange?: string
  currentTimeRange?: string
  isModalView?: boolean
}
const items = [
  { label: TIME_RANGE_LABELS.last_5_minutes, value: TIME_RANGES.last_5_minutes },
  { label: TIME_RANGE_LABELS.last_15_minutes, value: TIME_RANGES.last_15_minutes },
  { label: TIME_RANGE_LABELS.last_30_minutes, value: TIME_RANGES.last_30_minutes },
  { label: TIME_RANGE_LABELS.last_1_hour, value: TIME_RANGES.last_1_hour },
  { label: TIME_RANGE_LABELS.last_3_hours, value: TIME_RANGES.last_3_hours },
  { label: TIME_RANGE_LABELS.last_6_hours, value: TIME_RANGES.last_6_hours },
  { label: TIME_RANGE_LABELS.last_12_hours, value: TIME_RANGES.last_12_hours },
  { label: TIME_RANGE_LABELS.last_24_hours, value: TIME_RANGES.last_24_hours },
  { label: TIME_RANGE_LABELS.last_48_hours, value: TIME_RANGES.last_48_hours },
  { label: TIME_RANGE_LABELS.last_7_days, value: TIME_RANGES.last_7_days },
  { label: TIME_RANGE_LABELS.last_30_days, value: TIME_RANGES.last_30_days },
  { label: TIME_RANGE_LABELS.last_60_days, value: TIME_RANGES.last_60_days },
]
export function TimePicklist({
  onChange,
  currentTimeRange = TIME_RANGES.last_1_hour,
  isModalView,
}: Props) {
  const classes = useStyles()
  const handleOnChange = (selectedTimeRange) => {
    const { startTimeEpoch, endTimeEpoch, steps, interval } = getTimeRangeData(
      selectedTimeRange,
      isModalView,
    )
    onChange(selectedTimeRange, startTimeEpoch, endTimeEpoch, steps, interval)
  }

  useEffect(() => {
    if (!isModalView && currentTimeRange !== '') {
      handleOnChange(currentTimeRange || TIME_RANGES.last_1_hour)
    }
  }, [isModalView, currentTimeRange])
  return (
    <AsyncDropdown
      compact
      onChange={handleOnChange}
      items={items}
      value={currentTimeRange || TIME_RANGES.last_1_hour}
      className={classes.customDropdown}
    />
  )
}
export default TimePicklist

const useStyles = makeStyles((theme: Theme) => ({
  customDropdown: {
    '& .placeholder': {
      fontWeight: 400,
    },
    '& .dropdownMenu': {
      maxHeight: 250,
    },
  },
}))
